exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".schedule>div[data-v-23b44c8a]{display:flex;flex-wrap:wrap;gap:10px;align-items:flex-start}", ""]);

